"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActualMetricSettings = getActualMetricSettings;
exports.getChartTypes = void 0;
exports.getComparisonOptions = getComparisonOptions;
exports.getCrosstabComparisonOptions = getCrosstabComparisonOptions;
exports.getInitialMetricSettings = getInitialMetricSettings;
exports.getMetricSettingsToSave = getMetricSettingsToSave;
exports.getVisualizeAsOptions = getVisualizeAsOptions;
var _cccisdVisualize = require("cccisd-visualize");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _unset2 = _interopRequireDefault(require("lodash/unset"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _statsBars = _interopRequireDefault(require("cccisd-icons/stats-bars4"));
var _pieChart = _interopRequireDefault(require("cccisd-icons/pie-chart3"));
var _statsDots = _interopRequireDefault(require("cccisd-icons/stats-dots"));
var _meterMedium = _interopRequireDefault(require("cccisd-icons/meter-medium"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu3"));
var _objectHelpers = require("./objectHelpers.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getComparisonOptions(metric) {
  var excludedOptions = new Set();
  var result = [{
    label: 'No Comparison',
    value: 'none'
  }, {
    label: 'Crosstab',
    value: 'crosstab'
  }, {
    label: 'Group',
    value: 'grouptype'
  }, {
    label: 'Over Time',
    value: 'overtime'
  }].filter(function (item) {
    return !excludedOptions.has(item.value);
  });
  return result;
}
function getCrosstabComparisonOptions(metrics, currentMetric) {
  var options = metrics.filter(function (metric) {
    return metric["enum"] || ['boolean', 'integer'].includes(metric.type);
  }).map(function (metric) {
    var isCurrentMetric = metric.variableId === currentMetric.variableId;
    return {
      value: "variables.".concat(metric.reportHeader),
      label: "Metric - ".concat(metric.reportHeader).concat(isCurrentMetric ? ' (Selected Metric)' : ''),
      disabled: isCurrentMetric
    };
  });
  return options;
}
function getVisualizeAsOptions(_ref) {
  var metric = _ref.metric,
    metricSettings = _ref.metricSettings,
    crossMetric = _ref.crossMetric;
  var isMean = function () {
    if (!metric.statisticType.includes('numeric')) {
      return false;
    }
    if (metricSettings.comparison === 'overtime') {
      return true;
    }
    if (metricSettings.comparison === 'crosstab' && crossMetric && crossMetric.statisticType.includes('categorical')) {
      return true;
    }
    return false;
  }();
  var result = [{
    label: 'Distribution',
    value: 'dist'
  }];
  if (isMean && (['MC - select one', 'MC - select multiple', 'number', 'integer', 'slider'].includes(metric.questionType) || metric.type === 'formula')) {
    result.push({
      label: 'Mean',
      value: 'mean'
    });
  }
  return result;
}
var getChartTypes = exports.getChartTypes = function getChartTypes(_ref2) {
  var metric = _ref2.metric,
    metricSettings = _ref2.metricSettings,
    crossMetric = _ref2.crossMetric;
  var visualizeAs = metricSettings.visualizeAs,
    comparison = metricSettings.comparison;
  var questionTypesWithoutCharts = ['openEnded', 'date'];
  var options = [{
    name: 'bar',
    label: 'Bar',
    icon: _statsBars["default"],
    isDist: metric.statisticType.includes('categorical'),
    isMean: true
  }, {
    name: 'line',
    label: 'Line',
    icon: _statsDots["default"],
    isDist: true,
    isMean: true
  }, {
    name: 'pie',
    label: 'Pie',
    icon: _pieChart["default"],
    isDist: comparison !== 'crosstab' && comparison !== 'grouptype' && metric.statisticType.includes('categorical'),
    isMean: false
  }, {
    name: 'gauge',
    label: 'Gauge',
    icon: _meterMedium["default"],
    isDist: false,
    isMean: false
  }, {
    name: 'bullet',
    label: 'Bullet',
    icon: _menu["default"],
    isDist: false,
    isMean: metric.statisticType.includes('numeric') && comparison === 'crosstab' && (crossMetric === null || crossMetric === void 0 ? void 0 : crossMetric.statisticType.includes('categorical'))
  }];
  return options.filter(function (item) {
    if (questionTypesWithoutCharts.includes(metric.questionType)) {
      return false;
    }
    return visualizeAs === 'dist' ? item.isDist : item.isMean;
  });
};
function getDefaultNivoOptionsForChartTypes(common) {
  return {
    bar: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Bar.initialValues), common), {}, {
      keys: ['Responses'],
      showLegend: false,
      enableGridX: false,
      enableGridY: true,
      padding: 0.6
    }),
    line: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Line.initialValues), common), {}, {
      keys: ['Responses'],
      showLegend: false,
      enableGridX: true,
      enableGridY: true
    }),
    pie: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Pie.initialValues), common), {}, {
      showLegend: false
    }),
    swarm: _objectSpread(_objectSpread(_objectSpread({}, _cccisdVisualize.Swarm.initialValues), common), {}, {
      keys: ['Responses'],
      enableGridX: true,
      enableGridY: false,
      pointSize: 10
    }),
    gauge: _objectSpread(_objectSpread({}, _cccisdVisualize.Gauge.initialValues), common),
    bullet: _objectSpread(_objectSpread({}, _cccisdVisualize.Bullet.initialValues), common),
    none: {}
  };
}
function getInitialMetricSettings(metric) {
  var colors = 'pastel2';
  var comparison = 'none';
  var theme = {
    fontSize: 14
  };
  var nivoOptions = getDefaultNivoOptionsForChartTypes({
    theme: theme,
    colors: colors
  });
  var additionalSettings = {
    showLabel: true,
    showVariableLabel: false,
    showQuestion: true,
    showTotalResponses: true,
    showTable: true,
    showSummaryStats: true,
    chartHeight: 425,
    enableRollupThreshold: true,
    rollupThresholdValue: 10,
    aboveChart: '',
    belowChart: ''
  };
  switch (metric.questionType) {
    case 'MC - select one':
    case 'MC - select multiple':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'number':
      // TODO
      return;
    case 'integer':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'slider':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'line',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'boolean':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    case 'timestamp':
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'bar',
        nivoOptions: nivoOptions
      }, additionalSettings);
    default:
      if (metric.type === 'formula') {
        return _objectSpread({
          visualizeAs: 'dist',
          comparison: comparison,
          compareWith: '',
          compareByGroupType: '',
          chartType: 'line',
          nivoOptions: nivoOptions
        }, additionalSettings);
      }
      return _objectSpread({
        visualizeAs: 'dist',
        comparison: comparison,
        compareWith: '',
        compareByGroupType: '',
        chartType: 'none',
        nivoOptions: nivoOptions
      }, additionalSettings);
  }
}
function getActualMetricSettings(metric, settings) {
  var overrideInitialSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // as we removed theme custom color from UI and code, we need to remove it from already saved settings, just to avoid breaking changes
  var adjustedSettings = function () {
    if ((0, _get2["default"])(settings, 'nivoOptions.bar.colors') !== 'custom') {
      return settings;
    }
    var result = (0, _cloneDeep2["default"])(settings);
    (0, _unset2["default"])(result, 'nivoOptions.bar.colors');
    (0, _unset2["default"])(result, 'nivoOptions.bar.customColors');
    return result;
  }();
  var initialMetricSettings = (0, _objectHelpers.combine)(getInitialMetricSettings(metric), overrideInitialSettings);
  return (0, _objectHelpers.combine)(initialMetricSettings, adjustedSettings);
}
function getMetricSettingsToSave(metric, values) {
  var initialMetricSettings = getInitialMetricSettings(metric);
  var diff = (0, _objectHelpers.getDiff)(initialMetricSettings, values);
  if ((0, _isEmpty2["default"])(diff)) {
    return null;
  }
  return diff;
}